export default __webpack_public_path__ + "static/img/promo-icon-3-inactive.7a78c20.png";